import { render, staticRenderFns } from "./RenameSource.vue?vue&type=template&id=6c993df0&"
import script from "./RenameSource.vue?vue&type=script&lang=js&"
export * from "./RenameSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports